var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isNewHome)?_c('div',{attrs:{"id":"vheader"}},[_c('div',[_c('v-app-bar',{style:({
        zIndex: '9999998',
        padding: _vm.isMobile ? '0px' : '0px 30px',
        marginTop: _vm.isHome && !_vm.isMobile ? '40px' : '0px',
      }),attrs:{"fixed":!_vm.isHome,"absolute":_vm.isHome,"flat":"","dense":"","color":_vm.isHome || _vm.isNewHome ? 'rgba(0, 0, 0, 0)' : '#6cc091',"dark":""}},[_c('router-link',{staticStyle:{"font-size":"20px"},attrs:{"to":"/"}},[_vm._v("Ohana Movies")]),_c('v-spacer'),_c('Navigation')],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }